// firebase/index
export const firebaseConfig = {
  apiKey: "AIzaSyANzfVriacYChxC09ahUMTtWVSrndm8DqA",
  authDomain: "eventos-ohmygod.firebaseapp.com",
  projectId: "eventos-ohmygod",
  storageBucket: "eventos-ohmygod.appspot.com",
  messagingSenderId: "216351196269",
  appId: "1:216351196269:web:2e061e76f99ad3b36cab64",
  measurementId: "G-V7D0CXPBQ1"
}

// firebase/storage
export const storageUrl = 'https://firebasestorage.googleapis.com/v0/b/eventos-ohmygod.appspot.com/o/'